export default __webpack_public_path__ + "static/media/gynae.6961715e.svg";